import React, { useState, useEffect } from "react";

const About = () => {
    useEffect(() => {}, []);

    return <main className="admin-contents"></main>;
};

export default About;
